import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dextUrlInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map